/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Defines the default values for the report. Used to validate Report template filter values.
 */
export interface ReportFilterSettingView { 
    /**
     * Primary Key for the report filter.
     */
    reportFilterSettingId?: number;
    /**
     * Foreign key to the Reports table.
     */
    reportId?: number;
    /**
     * Name of the filter (e.g., location_id, period_type).
     */
    filterName?: string;
    /**
     * Specifies the data type of the filter, such as INTEGER, BOOLEAN, STRING, or TABLE_LOOKUP.
     */
    filterDataType?: string;
    /**
     * Indicates if the filter allows multiple values (e.g., TRUE for arrays).
     */
    isArray?: boolean;
    allowedValues?: string;
    /**
     * Name of the table to query for dynamic filter values (if applicable).
     */
    lookupTableName?: string;
    required?: boolean;
    /**
     * { tableName, sort, where, limit }; sequilize type filter for determining default values.
     */
    sqlDefaultValue?: any;
    /**
     * Value of the filter, stored as text to allow flexibility.
     */
    defaultValue?: string;
}